import {Component} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {NavigationEnd, Router} from '@angular/router';
import {environment} from '../environments/environment';
import {ChatbotService} from './shared/service/chatbot.service';
import {EditPersonalDataService} from './components/account/services/edit-personal-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ANRE';
  public open = false;
  public showBot = environment.showbot;
  loggedId: boolean;
  registerPath = false;
  chatUrl = environment.botUrl;

  constructor(
    private router: Router,
    private keycloakService: KeycloakService,
    private editPersonalDataService: EditPersonalDataService
  ) {

    this.keycloakService.isLoggedIn().then((res) => (this.loggedId = res));

    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd && e.url === '/inregistrare') {
        this.registerPath = true;
      }
    });

    // redirect to home if initial url is '/'
    if (this.keycloakService.getKeycloakInstance().authenticated === true) {
      this.router.events.subscribe((e) => {
        if (e instanceof NavigationEnd && e.url === '/' || e instanceof NavigationEnd && e.url === '') {
          const userRoles = this.keycloakService.getUserRoles();
          if (userRoles.indexOf('operator') > -1) {
            this.router.navigate(['operator']);
          } else if (userRoles.indexOf('supplier') > -1) {
            this.router.navigate(['furnizor']);
          } else if (userRoles.indexOf('anre') > -1) {
            this.router.navigate(['anre']);
          } else {
            this.router.navigate(['utilizator']);
          }
        }
      });
      this.editPersonalDataService.getPersonalInfo().subscribe((data) => {
        const userRoles = this.keycloakService.getUserRoles();
        if (
          userRoles.indexOf('operator') > -1 ||
          userRoles.indexOf('supplier') > -1 ||
          userRoles.indexOf('anre') > -1
        ) {
          return;
        }
        if (!data || !data.email) {
          this.router.navigate(['/inregistrare-roeid']);
        }
      });
    }
  }
}
